export default {
    // in v4/actions - init
    // should move to v4/modules/preference
    async setPreferences({ dispatch, commit }, payload) {
        let sucess = false
        try {
            commit('setPreferences', payload)
            sucess = true
        }
        catch (e) {}
        return sucess
    }
}
